import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `length` property of an object.
export default shallowProperty('length');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/_getLength.js
// module id = 37
// module chunks = 8